export function omit(object) {
  var keys = Object.keys(object);
  var result = {};

  for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];

    if (paths.indexOf(key) === -1) {
      result[key] = object[key];
    }
  }

  return result;
}
export function toArray(arg) {
  if (typeof arg === "undefined") return [];
  return Array.isArray(arg) ? arg : [arg];
}